import {
    BehaviorSubject
} from 'rxjs';

// import config from 'config';
import {
    requestOptions,
    handleResponse
} from '@/_helpers';

// Rol bayraklarını belirle. Öncelik: legacy username (admin/admin_web), yoksa backend'den gelen rol.
const applyRole = (user) => {
    if (!user) return user;
    const backendRole = user.role; // backend authenticate yanıtındaki gerçek rol (boş/null olabilir)
    if (user.username === 'admin') {
        user.role = 'Admin'; user.isAdmin = true; user.isAdminWeb = false; user.isEnvanterAdmin = false;
    } else if (user.username === 'admin_web') {
        user.role = 'AdminWeb'; user.isAdmin = true; user.isAdminWeb = true; user.isEnvanterAdmin = false;
    } else if (backendRole === 'EnvanterAdmin') {
        user.role = 'EnvanterAdmin'; user.isAdmin = true; user.isAdminWeb = false; user.isEnvanterAdmin = true;
    } else if (backendRole === 'AdminWeb') {
        user.role = 'AdminWeb'; user.isAdmin = true; user.isAdminWeb = true; user.isEnvanterAdmin = false;
    } else if (backendRole === 'Admin') {
        user.role = 'Admin'; user.isAdmin = true; user.isAdminWeb = false; user.isEnvanterAdmin = false;
    } else {
        user.role = 'User'; user.isAdmin = false; user.isAdminWeb = false; user.isEnvanterAdmin = false;
    }
    user.canAccessAdmin = !!user.canAccessAdmin;
    user.canManageLeaves = !!user.canManageLeaves;
    user.canViewPriceIncreaseLogs = !!user.canViewPriceIncreaseLogs;
    return user;
};

const getUserFromStorage = () => {
    return applyRole(JSON.parse(localStorage.getItem('currentUser')));
};

const currentUserSubject = new BehaviorSubject(getUserFromStorage());

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value;
    }
};

function login(username, password) {
    return fetch(`${process.env.VUE_APP_API}/api/users/authenticate`, requestOptions.post({
        username,
        password
    }))
        .then(handleResponse)
        .then(user => {
            applyRole(user);

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            localStorage.setItem('tenantId', user.tenantId);
            localStorage.setItem('selectedTenantId', user.tenantId);
            localStorage.setItem('selectedMpId', user.mpId);
            currentUserSubject.next(user);

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
}